import { getRoute, useLayout } from '@/functions';

export default {
    path: '/',
    component: useLayout('twofactor'),
    children: [
        getRoute('/two-factor-authentication', 'twoFactorAuthentication', 'twofactorauth/two_factor_authentication_page', { title: 'Enable Two Factor Authentication'}),
    ],
};